/**
 * <s-splash-gate> — full-screen opening image. Clicking it (or Enter, Space,
 * Escape) marks the session as seen, plays the CSS exit (data-leaving) and
 * removes the overlay so the page underneath becomes interactive.
 */
class SSplashGate extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.querySelector('[data-splash-enter]')?.addEventListener('click', () => this.enter(), opts);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' || event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.enter();
      }
    }, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  enter() {
    if (this.hasAttribute('data-leaving')) return;
    try {
      sessionStorage.setItem('splash-gate-seen', '1');
    } catch (error) {}
    this.setAttribute('data-leaving', '');
    document.getElementById('main-content')?.focus({ preventScroll: true });
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(() => this.remove(), reduce ? 820 : 950);
  }
}

if (!customElements.get('s-splash-gate')) {
  customElements.define('s-splash-gate', SSplashGate);
}
